<template>
  <div class="home">
    <!-- Swiper组件 -->
    <div class="top" v-if="false">
      <div class="banner-box">
        <div class="swiper-container" v-if="banner_list.length">
          <swiper :options="swiperOptions" ref="mySwiper">
            <!-- Slides -->
            <swiper-slide
              v-for="(item, index) in banner_list"
              :key="`banner-${index}`"
            >
              <img
                :src="item.image"
                class="swiper-img"
                @click="onBannerClick(item)" :alt="item.title || item.name || ''" />
            </swiper-slide>
          </swiper>
          <!-- Custom Buttons -->
          <button class="custom-prev-btn">
            <img
              src="@/assets/images/icon-prev-circle.png"
              style="width: 30px; height: 30px" alt="" />
          </button>
          <button class="custom-next-btn">
            <img
              src="@/assets/images/icon-next-circle.png"
              style="width: 30px; height: 30px" alt="" />
          </button>
        </div>
      </div>
      <div class="top-right">
        <div class="right-item">
          <img src="@/assets/images/index-top-right-1.png" alt="" />
        </div>
        <div class="right-item">
          <img src="@/assets/images/index-top-right-2.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 分类菜单 -->
    <div class="cate-box">
      <div class="cate-main">
        <Button
          class="cate-item"
          :class="selected_cate == 0 ? 'cate-item-active' : ''"
          @click="onChangeCate(0)"
        >
          推荐
        </Button>
        <Button
          class="cate-item"
          style=""
          v-for="(item, index) in displayCategory"
          type="text"
          :class="selected_cate === item.id ? 'cate-item-active' : ''"
          @click="onChangeCate(item)"
          :key="index"
          >{{ item.cate_name }}</Button
        >
        <img
          src="@/assets/images/icon-arrow-down.png"
          class="more"
          :class="showAllCategory ? 'more-active' : ''"
          @click="showAllCategory = !showAllCategory" alt="" />
      </div>
    </div>
    <!-- 瀑布流组件 -->
    <div class="list-box">
      <div
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
      <!-- <masonry-layout ref="masonryWall">
        <div v-for="(item, index) in infiniteList" :key="index" class="masonry-item">
          <img :src="item.cover" @load="onImageLoad" :alt="item.title || ''" />
        </div>
      </masonry-layout> -->
        <CustomeMasonry
          ref="masonryWall"
          :cols="{ default: 6, 1700: 5, 1600: 5, 1500: 5, 1400: 4, 1300: 4 }"
          :gutter="{
            default: '20px',
            1700: '20px',
            1600: '20px',
            1500: '20px',
            1400: '20px',
            1300: '20px',
          }"
          :refreshKey="`cm-${refreshKey}`"
        >
        <!-- class="animate__animated animate__fadeInUp" -->
          <div
            v-for="(item, index) in infiniteList"
            :key="item.uuid"
            @click="onArticleDetail(item)"
          >
            <template>
              <div class="masonry-item" :ref="`masonryItem${index}`" :key="`masonry${index}`">
                <img
                  v-if="item.type == 2"
                  src="../assets/images/icon-play.png"
                  style="
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    z-index: 10;
                  "
                  alt=""
                />
                <div class="image-container">
                  <!-- :src="" -->
                   <!-- v-lazy="item.cover" -->
                  <img
                    :src="item.cover | default_img"
                    @load="onImageLoad"
                    class="masonry-image" :alt="item.title || ''" />
                </div>
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="bottom-box">
                    <div class="nick-avatar">
                      <img
                        class="avatar"
                        :src="item.member.avatar | default_img" :alt="(item.member && item.member.nickname) || ''" />
                      <div class="nick">
                        {{ item.member.nickname || item.member.username }}
                      </div>
                    </div>
                    <div class="like-box">
                      <img
                        src="../assets/images/icon-like.png"
                        style="width: 16px; height: 16px" alt="" />
                      <div style="margin-left: 3px">{{ item.zan_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </CustomeMasonry>
      </div>
    </div>
    <!-- 底部未登录状态 -->
    <div
      class="no-login"
      v-if="!is_login"
      :style="{ bottom: fully_footer === true ? '50px' : 0 }"
    >
      <div class="slogan">
        <span>衣创社区</span> 让灵感点亮世界，让创意成就品牌
      </div>
      <div class="login-box">
        <div class="more">登录了解更多 》</div>
        <img
          src="../assets/images/icon-nologin-red-phone.png"
          @click="onLogin('phone')"
          class="login-by-phone" alt="" />
        <img
          src="../assets/images/icon-nologin-wechat.png"
          @click="onLogin('wechat')"
          class="login-by-wechat" alt="" />
      </div>
    </div>
    <!-- 返回顶部 -->
    <img
      v-show="isBackToTopVisible"
      src="../assets/images/icon-to-top.png"
      @click="scrollToTop"
      class="scroll-top"
      ref="backToTop" alt="" />
    <!-- 右侧固定菜单 -->
    <div class="right-menu">
      <img src="../assets/images/icon-right-menu.png" class="right-menu" alt="" />
      <div class="right-menu-box">
        <div class="menu-box">
          <div class="menu-item" @click="$router.push({ name: 'Login' })">
            <img src="../assets/images/icon-about-us-right.png" alt="" />
            关于我们
          </div>
          <div
            class="menu-item"
            @click="$router.push({ name: 'BusinessCooperation' })"
          >
            <img src="../assets/images/icon-business-right.png" alt="" />
            商务合作
          </div>
          <div class="menu-item" @click="showChat">
            <img src="../assets/images/icon-custom-right.png" alt="" />
            客服帮助
          </div>
          <div class="menu-item" @click="$router.push({ name: 'UserAppeal' })">
            <img src="../assets/images/icon-appeal-right.png" alt="" />
            侵权申诉
          </div>
        </div>
        <div class="menu-item"  @click="go2">
          <img src="../assets/images/icon-appeal-right.png" alt="" />
          版师入驻
        </div>
      </div>
    </div>
    <!-- 文章详情 -->
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="article_id"
    ></ArticleDetail>

    <Chat ref="chat"></Chat>
  </div>
</template>

<script>
import { GetBannerList, GetCategoryList, addUserContribution } from "@/api";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import { GetPostsList } from "@/api/social";
import ArticleDetail from "@/components/ArticleDetail";
import infiniteMix from "@/mixins/infinite";
import { mapState } from 'vuex';
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    ArticleDetail,
  },
  mixins: [infiniteMix],
  data() {
    return {
      category_list: [],
      showAllCategory: false,
      selected_cate: 0,
      swiperOptions: {
        // 核心配置
        slidesPerView: 1, // 每页显示 1.5 张幻灯片（中间完整显示，前后各显示半张）
        centeredSlides: true, // 当前幻灯片居中显示
        spaceBetween: 20, // 幻灯片间距
        loop: true, // 启用循环模式
        loopedSlides: 0,
        grabCursor: true, // 拖动时显示抓手光标
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 手动滑动后继续自动播放
        },
        // 导航按钮配置
        navigation: {
          prevEl: ".custom-prev-btn",
          nextEl: ".custom-next-btn",
        },
      },
      isBackToTopVisible: false,
      show_detail: false,
      article_id: "",
      banner_list: [],
      fully_footer: false,
      loadingMore: false,
      first_loading: true,
      // bottom_height:50
      observer: null,
      lastScrollTop:0,
      refreshKey:0,
      timeInterval:null,
      readTime:0
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  async mounted() {
    // if(this.$store.state.is_login) {
    // 	this.$router.push({name: 'WorkBenchHome'})
    // } else {
    // 	this.$router.push({name: 'Login'})
    // }
    // this.$parent.showFooter(true);
    // this.$parent.footer_style = 'light';
    window.addEventListener("scroll", this.handleScroll);
    await this.onGetBannerList();
    await this.onGetCateList();
    await this.getInfiniteList(true);
    this.first_loading = false;
    // 初始化 IntersectionObserver
    this.initInfiniteScrollObserver();
    this.observeAllItems();
    this.checkItemsVisibility();
    this._bindTransitionEndEvents();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  created() {
    const { uuid,code } = this.$route.params;
    if (uuid) {
      this.article_id = uuid;
      this.show_detail = true;
      this.timeInterval = setInterval(() => {
        this.readTime++
      }, 1000);
    }
    if(code && code != this.userInfo.code) {
      //分享链接进来
      addUserContribution({
        uuid: this.uuid,
        code,
        action_type:'postShare'
      })
    }
    this.infinitePageSize = 15;
  },
  computed: {
     ...mapState(['taskSetting','userInfo']),
    displayCategory() {
      return this.showAllCategory
        ? this.category_list
        : this.category_list.slice(0, 9);
    },
    is_login() {
      return this.$store.state.is_login;
    },
  },
  watch: {
    infiniteList: {
      handler(newVal, oldVal) {
        // 只有当数据长度变化时触发重排
        if (newVal.length !== oldVal.length) {
          this.$nextTick(() => {
            if (this.$refs.masonryWall) {
              // 批量处理
              requestAnimationFrame(() => {
                this.$refs.masonryWall.reCalculate();
              });
            }
          });
        }
      },
      deep: true
    },
    infiniteEnded(news){
      if(news){
        if(this.$refs.masonryWall){
          console.log('加载结束重新触发计算')
          this.$nextTick(() => {
            if (!this.$refs.masonryWall) {
              console.log("masonryWall未定义");
            } else {
              this.$refs.masonryWall?.reCalculate();
              // console.log("成功触发reCalculate");
            }
          });
        }
      }
    },
    readTime(value) {
      if(value >= this.taskSetting.postRead.needTime && this.is_login) {
        console.log(this.userInfo)
        addUserContribution({
          uuid: this.article_id,
          user_id:this.userInfo.id,
          action_type:'postRead'
        })
        clearInterval(this.timeInterval)
        this.readTime = 0
      }
    }
  },
  methods: {
    go2() {
      location.href='/patternMakerRegister'
    },
    _bindTransitionEndEvents() {
      const items = document.querySelectorAll(".masonry-item");
      items.forEach(item => {
        item.addEventListener("transitionend", () => {
          this.$nextTick(() => {
            // this.$refs.masonryWall?.reCalculate(); // 动画完成后重新计算
          });
        });
      });
    },
    checkItemsVisibility() {
      const items = document.querySelectorAll(".masonry-item");
      items.forEach((item) => {
        if (!item.classList.contains("visible")) {
          const rect = item.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom >= 0) {
            item.classList.add("visible");
            this.observer.unobserve(item); // 可选：只播放一次动画
          }
        }
      });
    },
    observeAllItems() {
      const items = document.querySelectorAll(".masonry-item");
      items.forEach((item) => {
        this.observer.observe(item);
      });
    },
    initInfiniteScrollObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              this.observer.unobserve(entry.target); //>只播放一次动画
            }
          });

          const lastEntry = entries[entries.length - 1];
          if (
            lastEntry.isIntersecting &&
            !this.loadingMore &&
            !this.infiniteEnded
          ) {
            this.loadingMore = true;
            this.getInfiniteList().finally(() => {
              this.loadingMore = false;
              this.$nextTick(() => {
                this.observeAllItems();
              });
            });
          }
        },
        {
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
    },
    observeLastItem() {
      const items = document.querySelectorAll(".masonry-item");
      if (items.length > 0) {
        this.observer.observe(items[items.length - 1]);
      }
    },
    showChat() {
      // console.log('showchat',this.$refs['chat']);
      // this.$refs["chat"].showChat();
      this.$nextTick(() => {
        this.$refs.chat.showChat();
      });
    },
    onLogin(type) {
      switch (type) {
        case "phone":
          this.$router.push({ name: "Login", query: { type: "phone" } });
          break;
        case "wechat":
          this.$router.push({ name: "Login", query: { type: "wechat" } });
          break;
      }
    },
    getInfiniteData(pageIndex, pageSize) {
      const { selected_cate } = this;
      console.log("pagesize", pageSize);
      return GetPostsList({
        page: pageIndex,
        limit: pageSize,
        category_id: selected_cate,
      });
    },
    async onGetCateList() {
      const { data } = await GetCategoryList({});
      this.category_list = data;
    },
    onBannerClick(data) {
      if (!data.url) return;
      this.image_redirect(data.url);
    },
    async onGetBannerList() {
      try {
        const param = {};
        param.position = 1;
        const { data } = await GetBannerList(param);
        this.swiperOptions.loopedSlides = data.length;
        this.banner_list = data;
      } catch (e) {
        console.log("e-banner", e);
      }
    },
    onArticleDetail(data) {
      this.article_id = data.uuid;
      this.show_detail = true;
       this.timeInterval = setInterval(()=>{
        this.readTime ++
      },1000)
    },
    onCloseArticleDetail(e) {
      console.log("关闭弹窗");
      this.show_detail = false;
      clearInterval(this.timeInterval)
      this.readTime = 0
    },
    // onReachBottom:_.debounce(function(){
    //   this.$nextTick(() => {
    //     const el = this.$parent.$refs.footer.$el;
    //     if (!el) return;

    //     const rect = el.getBoundingClientRect();

    //     // 页面滚动到底部还剩 50px 时触发
    //     const offsetBottom = rect.top - window.innerHeight;
    //     console.log('offsetBottom',offsetBottom);
    //     if (offsetBottom <= 500) {
    //       if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
    //       console.log('触发触底加载...',new Date().getTime());
    //       this.loadingMore = true;
    //       this.getInfiniteList().finally(() => {
    //         this.loadingMore = false;
    //       });
    //     }
    //   });
    // },100),
    onReachBottom() {
      // 获取当前滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 保存上一次滚动位置
      if (typeof this.lastScrollTop === 'undefined') {
        this.lastScrollTop = 0;
      }

      if(scrollTop < this.lastScrollTop){
        return;
      }

      this.lastScrollTop = scrollTop;

      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;
        // console.log('offsetBottom',offsetBottom);
        if (offsetBottom <= 3000) {
          if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
          // console.log('触发触底加载...',new Date().getTime());
          this.loadingMore = true;
          this.getInfiniteList().finally(() => {
            this.$nextTick(() => {
              if (!this.$refs.masonryWall) {
                console.log("masonryWall未定义");
              } else {
                // this.$refs.masonryWall?.reCalculate();
                // console.log("成功触发reCalculate");
              }
            });
            this.refreshKey++;
            this.loadingMore = false;
          });
        }
      });
    },
    async handleScroll() {
      await this.onReachBottom();
      await this.checkItemsVisibility();
      await this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;

        if (offsetBottom <= 50) {
          this.fully_footer = true;
        } else {
          this.fully_footer = false;
        }
      });
      this.isBackToTopVisible = window.pageYOffset > 300; // 滚动超过 300px 显示
      // this.observeAllItems();
    // this.checkItemsVisibility();
    },
    isElementFullyVisible(el) {
      const rect = el.getBoundingClientRect();
      console.log("rect", rect);
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async onChangeCate(item) {
      if (item == 0) {
        this.selected_cate = item;
      } else {
        this.selected_cate = item.id;
      }
      await this.getInfiniteList(true);
      // this.observeAllItems();
      // this.checkItemsVisibility();
    },
    onImageLoad() {
      // console.log("触发加载...");
      this.$nextTick(() => {
        // this.
        // this.observeAllItems();
      });
    },
    async getNewsList() {},
    go2article(article) {
      if (article.show_type == 9) {
        window.open(article.external_link);
      } else {
        this.$router.push({
          path: "/detail",
          query: {
            id: article.content_id,
          },
        });
      }
    },
    more() {
      this.$router.push({
        path: "/news",
      });
    },
    pick(value) {
      this.$store.commit("mtm/pick", { category: value });
    },
    async getTemplateList() {},
    init() {},
    image_redirect(url) {
      if (url.includes("http")) {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &::-webkit-scrollbar{
    display:none;
  }
  //   margin-top: 15px;
}

.top {
  display: flex;
  //   align-items: center;
  column-gap: 20px;
  align-items: stretch;
  height: 400px;
  width: 100%;
  justify-content: center;
}

.top-right {
  display: flex;
  flex-direction: column;
  // flex-wrap:wrap;
  row-gap: 16px;
  //   flex:1;
  min-width: 0;
  //   width:100%;
  //   height:100%;
  overflow: hidden;
  border-radius: 10px;
  .right-item {
    width: 100%;
    max-width: 700px;
    height: 100%;
    max-height: 192px;
    border-radius: 10px;
    background: #f2f2f2;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
  }
}

.banner-box {
  width: 1000px;
  overflow: hidden;
  flex-shrink: 0;
  display:flex;
}

.list-box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.no-login {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 140px 20px 56px;
  z-index: 11;
  .slogan {
    font-size: 28px;
    span {
      color: #ff5967;
    }
  }
  .login-box {
    display: flex;
    justify-content: end;
    align-items: center;
    .more {
      color: #808080;
      font-size: 14px;
    }
    .login-by-phone {
      width: 33px;
      height: 33px;
      margin: 0 20px;
      cursor: pointer;
    }
    .login-by-wechat {
      width: 120px;
      height: 32px;
      cursor: pointer;
    }
  }
}

.scroll-top {
  position: fixed;
  bottom: 130px;
  right: 34px;
  width: 46px;
  height: 46px;
  cursor: pointer;
  z-index: 30;
}

.right-menu {
  position: fixed;
  bottom: 80px;
  right: 34px;
  width: 46px;
  height: 46px;
  z-index: 30;
  cursor: pointer;
  &:hover .right-menu-box {
    display: block;
  }
  .right-menu-box {
    display: none;
    position: absolute;
    top: -300%;
    left: -405%;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 3px 9px 3px #e0e0e0;
    width: 185px;
    .menu-box {
      padding: 20px;
      display: flex;
      flex-direction: column;
      .menu-item {
        display: flex;
        align-items: center;
        column-gap: 15px;
        width: 100%;
        height: 40px;
        img {
          width: 22px;
          height: 22px;
        }
        .text {
          color: #1c1f23;
          font-size: 14px;
        }
        &:hover {
          background: #f7f9fa;
          border-radius: 6px;
        }
      }
    }
  }
}

.cate-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  .cate-main {
    width: 1100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .more {
      width: 14px;
      height: 14px;
      cursor: pointer;
    }

    .more-active {
      transform: rotate(180deg);
      transition: transform 0.3s ease;
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(180deg);
      }
    }

    .cate-item {
      border-radius: 16px;
      margin-left: 10px;
      margin-right: 10px;
      border: none;
      font-size: 15px;
      color:#1c1f23;
      &:hover {
        background: #000000;
        border-radius: 16px;
        border: none;
        color: #ffffff;
        margin-left: 10px;
        margin-right: 10px;
      }
    }

    .cate-item-active {
      background: #000000;
      border-radius: 16px;
      border: none;
      color: #ffffff;
      margin-left: 10px;
      margin-right: 10px;

      // &:hover {
      // 	background: #000000;
      // 	border-radius: 16px;
      // 	border: none;
      // 	color: #ffffff;
      // 	margin-left: 10px;
      // 	margin-right: 10px;
      // }
    }
  }
}

/**瀑布流样式开始 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.masonry-container {
  width: 1700px;
  max-width: 1700px;
  margin: 0 auto;
  will-change: contents;
   /* 减少布局边界计算 */
  //  contain: strict;
  /* 启用GPU加速 */
  transform: translateZ(0);
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: flex-start;
  .masonry-item {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    width: 270px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    isolation: isolate;
    opacity: 0.5;
    transform: translateY(40px);
    transition: opacity 0.6s ease, transform 0.6s ease;
    .image-container {
      position: relative;
      display: inline-block;
      width: 100%;
      img {
        display: block;
        width: 100%;
        height: auto;
      }

      &:hover::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(128, 128, 128, 0.4);
        pointer-events: none;
        border-radius: 10px;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(128, 128, 128, 0.05);
        pointer-events: none;
        border-radius: 10px;
      }
      .masonry-image {
        width: 100%;
        display: block;
        object-fit: contain;
        border-radius: 10px;
      }
    }

    .item-content {
      padding: 15px 5px;
      .title {
        font-size: 16px;
        color: #000000;
      }
      .bottom-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

        .nick-avatar {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: start;

          .avatar {
            width: 25px;
            height: 25px;
            border-radius: 100%;
          }

          .nick {
            max-width: 110px;
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
            color:#5c5c5c;
          }
        }

        .like-box {
          display: flex;
          align-items: center;
          flex: 0 0 40%;
          justify-content: end;
        }
      }
    }
  }
  .masonry-item.visible {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整列数 */
// @media (max-width: 768px) {
// 	.masonry-container {
// 		--columns: 2;
// 	}
// }

// @media (max-width: 480px) {
// 	.masonry-container {
// 		--columns: 1;
// 	}
// }
/**瀑布流样式结束 */

/**swiper样式调整开始 */
.swiper-container {
  position: relative;
  /* 确保按钮定位参考容器 */
  width: 100%;
  height: 400px;
  border-radius: 5px;
  overflow: visible;
  display:flex;
  /* 允许前后幻灯片溢出显示 */
  //   &:hover {
  //     .custom-prev-btn,
  //     .custom-next-btn {
  //       display: inline-block;
  //     }
  //   }
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  // width:1380px;
  /* 幻灯片宽度占容器的 80% */
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

// .swiper-container::before {
//   left: 0;
//   // background: rgba(255,255,255,0.3);
//   border-radius: 5px;
// }

// .swiper-container::after {
//   right: 0;
//   // background: rgba(255,255,255,0.3);
//   border-radius: 5px;
// }

/* 蒙版样式 */
// .swiper-container::before,
// .swiper-container::after {
//   content: "";
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   width: 250px; /* 覆盖左右蒙版区域 */
//   z-index: 9;
// }

/* 调整导航按钮位置到中间 */
.custom-prev-btn,
.custom-next-btn {
  position: absolute;
  top: 55%;
  transform: translateX(-50%) translateY(-50%);
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
  z-index: 10;
  display: none; // 默认隐藏
}

.swiper-container:hover .custom-prev-btn,
.swiper-container:hover .custom-next-btn {
  display: inline-block; // hover 时显示
}

.custom-prev-btn {
  left: 5%;
  // transform: translateX(-50%) translateY(-50%);
}

.custom-next-btn {
  right: 2%;
  // transform: translateX(-50%) translateY(-50%);
}

.swiper-img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/**Swiper样式调整结束 */

@media (min-width: 1280px) and (max-width: 1679px) {
  .home {
    width: 1679px !important;
    min-width: 1280px !important;
    max-width: 1679px !important;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    // margin-top: 30px;
  }

  .top-right {
    display: flex;
    flex-direction: column;
    // flex-wrap:wrap;
    row-gap: 16px;
    //   flex:1;
    min-width: 0;
    //   width:100%;
    //   height:100%;
    overflow: hidden;
    border-radius: 10px;
    .right-item {
      width: 100%;
      max-width: 600px;
      height: 100%;
      max-height: 192px;
      border-radius: 10px;
      background: #f2f2f2;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left;
        border-radius: 10px;
      }
    }
  }

  .banner-box {
    width: 100%;
    flex: 1;
    border-radius: 5px;
    // min-width:1280px;
    // max-width:1679px;
    // overflow:hidden;
  }

  .list-box {
    width: 100%;
    flex: 1;
    // min-width:1280px;
    // max-width:1679px;
  }

  .no-login {
    width: 100vw;
    position: fixed;
    bottom: 0;
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 140px 20px 56px;
  }

  .scroll-top {
    position: fixed;
    bottom: 130px;
    right: 34px;
    width: 46px;
    height: 46px;
    cursor: pointer;
  }

  .cate-box {
    margin-top: 27px;
    .cate-main {
      width: 990px;
      .more {
        width: 12.6px;
        height: 12.6px;
      }

      .more-active {
        transform: rotate(180deg);
        transition: transform 0.3s ease;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(180deg);
        }
      }

      .cate-item {
        border-radius: 16px;
        margin-left: 10px;
        margin-right: 10px;
        border: none;
        font-size: 13px;
        &:hover {
          background: #000000;
          border-radius: 16px;
          border: none;
          color: #ffffff;
          margin-left: 10px;
          margin-right: 10px;
        }
      }

      .cate-item-active {
        background: #000000;
        border-radius: 16px;
        border: none;
        color: #ffffff;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }

  /**瀑布流样式开始 */
  .masonry-container {
    width: 1280px;
    min-width: 1280px;
    max-width: 1400px;
    margin: 0 auto;
    .masonry-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      width: 243px;
      .masonry-image {
        width: 100%;
        display: block;
        object-fit: contain;
        border-radius: 10px;
      }

      .item-content {
        padding: 13.5px 4.5px;
        .title {
          font-size: 14px;
        }
        .bottom-box {
          margin-top: 9px;

          .nick-avatar {
            .avatar {
              width: 22.5px;
              height: 22.5px;
              border-radius: 100%;
            }

            .nick {
              max-width: 99px;
              margin-left: 9px;
              font-size: 11px;
            }
          }

          .like-box {
            flex: 0 0 30%;
          }
        }
      }
    }
  }
  /**瀑布流样式结束 */

  /**swiper样式调整开始 */
  .swiper-container {
    position: relative;
    /* 确保按钮定位参考容器 */
    width: 100%;
    // min-width: 1280px;
    // max-width: 1679px;
    flex: 1;
    height: auto !important;
    min-height: 324px;
    overflow: visible;
    display:flex;
    /* 允许前后幻灯片溢出显示 */
    &:hover {
      .custom-prev-btn,
      .custom-next-btn {
        display: inline-block;
      }
    }
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* 幻灯片宽度占容器的 80% */
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  //   .swiper-container::before {
  //     left: 0;
  //     background: rgba(255, 255, 255, 0.3);
  //     border-radius: 5px;
  //   }

  //   .swiper-container::after {
  //     right: 0;
  //     background: rgba(255, 255, 255, 0.3);
  //     border-radius: 5px;
  //   }

  //   /* 蒙版样式 */
  //   .swiper-container::before,
  //   .swiper-container::after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     bottom: 0;
  //     width: 13%; /* 覆盖左右蒙版区域 */
  //     z-index: 9;
  //   }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 220px;
    transform: translateX(-50%) translateY(-50%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
    display: none;
  }

  .custom-prev-btn {
    left: 5%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  /**Swiper样式调整结束 */
}

@media (max-width: 1279px) {
  .home {
    width: 1279px !important;
    min-width: 800px !important;
    max-width: 1279px !important;
    flex: 1;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    // margin-top: 24px;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .banner-box {
    // width: 100%;
    flex: 1;
    overflow: hidden;
    border-radius: 10px;
  }

  .top-right {
    display: flex;
    flex-direction: column;
    // flex-wrap:wrap;
    row-gap: 16px;
    //   flex:1;
    min-width: 0;
    //   width:100%;
    //   height:100%;
    overflow: hidden;
    border-radius: 10px;
    .right-item {
      width: 100%;
      max-width: 500px;
      height: calc(50vh - 8px);
      max-height: 192px;
      border-radius: 10px;
      background: #f2f2f2;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left;
        border-radius: 10px;
      }
    }
  }

  .list-box {
    width: 1279px;
  }

  .no-login {
    width: 1279px;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 112px 20px 44.8px;
  }

  .scroll-top {
    position: fixed;
    bottom: 130px;
    right: 34px;
    width: 46px;
    height: 46px;
    cursor: pointer;
  }

  .cate-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

    .cate-main {
      width: 1100px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      .more {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }

      .more-active {
        transform: rotate(180deg);
        transition: transform 0.3s ease;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(180deg);
        }
      }

      .cate-item {
        border-radius: 16px;
        margin-left: 10px;
        margin-right: 10px;
        border: none;
        font-size: 15px;
        &:hover {
          background: #000000;
          border-radius: 16px;
          border: none;
          color: #ffffff;
          margin-left: 10px;
          margin-right: 10px;
        }
      }

      .cate-item-active {
        background: #000000;
        border-radius: 16px;
        border: none;
        color: #ffffff;
        margin-left: 10px;
        margin-right: 10px;

        // &:hover {
        // 	background: #000000;
        // 	border-radius: 16px;
        // 	border: none;
        // 	color: #ffffff;
        // 	margin-left: 10px;
        // 	margin-right: 10px;
        // }
      }
    }
  }

  /**瀑布流样式开始 */
  .masonry-container {
    width: 1100px;
    max-width: 1100px;
    margin: 0 auto;

    .masonry-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      width: 216px;
      cursor: pointer;
      position: relative;
      .masonry-image {
        width: 100%;
        display: block;
        object-fit: contain;
        border-radius: 10px;
      }

      .item-content {
        padding: 15px 5px;
        .title {
          font-size: 14px;
          color: #000000;
        }
        .bottom-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          .nick-avatar {
            display: flex;
            align-items: center;
            flex: 1;
            justify-content: start;

            .avatar {
              width: 25px;
              height: 25px;
              border-radius: 100%;
            }

            .nick {
              max-width: 110px;
              margin-left: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 13px;
            }
          }

          .like-box {
            display: flex;
            align-items: center;
            flex: 0 0 40%;
            justify-content: end;
          }
        }
      }
    }
  }

  // /* 响应式调整列数 */
  // @media (max-width: 768px) {
  // 	.masonry-container {
  // 		--columns: 2;
  // 	}
  // }

  // @media (max-width: 480px) {
  // 	.masonry-container {
  // 		--columns: 1;
  // 	}
  // }
  /**瀑布流样式结束 */

  /**swiper样式调整开始 */
  .swiper-container {
    position: relative;
    /* 确保按钮定位参考容器 */
    width: 100%;
    min-width: 700px;
    max-width: 1279px;
    height: auto !important;
    min-height: 288px;
    overflow: visible;
    display:flex;
    /* 允许前后幻灯片溢出显示 */
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // width:1380px;
    /* 幻灯片宽度占容器的 80% */
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  //   .swiper-container::before {
  //     left: 0;
  //     background: rgba(255, 255, 255, 0.3);
  //     border-radius: 5px;
  //   }

  //   .swiper-container::after {
  //     right: 0;
  //     background: rgba(255, 255, 255, 0.3);
  //     border-radius: 5px;
  //   }

  /* 蒙版样式 */
  //   .swiper-container::before,
  //   .swiper-container::after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     bottom: 0;
  //     width: 12.5%; /* 覆盖左右蒙版区域 */
  //     z-index: 9;
  //   }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    display: none;
  }

  .swiper-container:hover .custom-prev-btn,
  .swiper-container:hover .custom-next-btn {
    display: inline-block;
  }

  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 21%;
    transform: translateX(-50%) translateY(-50%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
    display: none; // 默认隐藏
  }

  .custom-prev-btn {
    left: 5%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  /**Swiper样式调整结束 */
  // 	.home {
  //     transform: scale(0.8);
  //     transform-origin: top left;
  //     overflow-x: auto;
  //   }
}
</style>
